module.exports = __webpack_public_path__ + "static/sinead-slideshow-02@2x-8d6f6a5fba56c40d6448762bafdb9e8b.jpg";